import styled from 'styled-components'

import { device, variables } from 'src/Styled/variables'

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  width: 320px;
  min-width: 288px;
  padding: 32px;
  background: ${({ theme }) => theme.color.white};
  border: 1px solid ${({ theme }) => theme.color.lightGrey};
  border-radius: 16px;
  box-shadow: 0 0 20px 0 rgba(52, 52, 52, 0.3);

  @media ${device.mobileMin} {
    width: 600px;
    min-width: 600px;
    max-width: 600px;
    padding: 48px;
  }
`

export const Title = styled.h2`
  width: 100%;
  margin: 0;
  color: ${({ theme }) => theme.color.darkGrey};
  text-align: center;
  font-family: 'Segoe UI';
  font-size: 20px;
  font-style: normal;
  font-weight: ${variables.fontWeight600};
  line-height: 150%;

  @media ${device.mobileMin} {
    font-size: 28px;
  }
`

export const ButtonsColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  width: 100%;
`

export const Footer = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  gap: 4px;
`

export const FooterText = styled.p`
  margin: 0;
  color: ${({ theme }) => theme.color.darkGrey};
  font-family: 'Segoe UI';
  font-size: ${variables.fontSize14};
  font-style: normal;
  font-weight: ${variables.fontWeight400};
  line-height: 150%;
  white-space: nowrap;
`

export const FooterLinkButton = styled.button`
  padding: 0;
  border: none;
  border-bottom: 1px dashed ${({ theme }) => theme.color.darkGrey};
  background: none;
  color: ${({ theme }) => theme.color.darkGrey};
  font-family: 'Segoe UI';
  font-size: ${variables.fontSize14};
  font-style: normal;
  font-weight: ${variables.fontWeight400};
  line-height: 150%;
  white-space: nowrap;
  cursor: pointer;

  &:focus-visible {
    outline: 1px solid ${({ theme }) => theme.color.darkGreen};
    outline-offset: 2px;
  }
`
